import { render, staticRenderFns } from "./SortFilter.vue?vue&type=template&id=138cfa99&scoped=true&"
import script from "./SortFilter.vue?vue&type=script&lang=js&"
export * from "./SortFilter.vue?vue&type=script&lang=js&"
import style0 from "./SortFilter.vue?vue&type=style&index=0&id=138cfa99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cfa99",
  null
  
)

export default component.exports